import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Api\Internal\Me\ReportTemplateController::__invoke
* @see app/Http/Controllers/Api/Internal/Me/ReportTemplateController.php:19
* @route '/internal-api/me/report-templates'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/internal-api/me/report-templates',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Api\Internal\Me\ReportTemplateController::__invoke
* @see app/Http/Controllers/Api/Internal/Me/ReportTemplateController.php:19
* @route '/internal-api/me/report-templates'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Api\Internal\Me\ReportTemplateController::__invoke
* @see app/Http/Controllers/Api/Internal/Me/ReportTemplateController.php:19
* @route '/internal-api/me/report-templates'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Api\Internal\Me\ReportTemplateController::__invoke
* @see app/Http/Controllers/Api/Internal/Me/ReportTemplateController.php:19
* @route '/internal-api/me/report-templates'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

const reportTemplates = {
    index: Object.assign(index, index),
}

export default reportTemplates